<template>
    <div name="tabs" class="tabs-wrapper">
        <div @click="onClick(index)" :class="index === selectedIndex ? 'active-button' : 'inactive-button'" v-for="(info, index) in list" :key="`button_${index}`">
            {{info}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'tabsWrapper',
    props: ['list', 'selectedIndex'],
    methods: {
        onClick(index) {
            this.$emit('onClick', index)
        }
    }
}
</script>

<style scoped>
    .tabs-wrapper {
        width: calc(100% + 32px);
        margin-left: -16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        box-sizing: border-box;
        gap: 8px;
        border-bottom: 1px solid #EDEEF0;
    }
    .active-button {    
        display: flex;
        height: 100%;
        justify-content: center;
        height: 37px;
        align-items: flex-start;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 16px;
        border-bottom: 1.5px solid #1E1E1E;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .inactive-button {
        display: flex;
        height: 100%;
        justify-content: center;
        height: 37px;
        align-items: flex-start;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 16px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/Tabs.vue